/**
  基础信息变更时间线-时间线查询
  POST /baseinfo/timeline/list
  接口ID：218187297
  接口地址：https://app.apifotwitter.com/link/project/4556737/apis/api-218187297
 */

import { post } from "../utils/fetch";

/**
 * BaseinfoTimelineVo
 */

export var apiBaseinfoTimelineList = function apiBaseinfoTimelineList(data) {
  return post({
    url: '/baseinfo/timeline/list',
    data: data
  });
};